import { defineStore } from "pinia";

export type SubscriptionPlanResponse =
  | "admin"
  | "plugin_50"
  | "plugin_expansion"
  | "plugin_unlimited_yearly"
  | "plugin_unlimited_monthly"
  | "plugin_1000";

export type SubscriptionPlan =
  | "admin"
  | "plugin_startup"
  | "plugin_expansion"
  | "plugin_all_features";

interface State {
  subscriptionPlan: SubscriptionPlan | null;
}

export const usePlanTypeStore = defineStore("planTypeStore", {
  state: (): State => ({
    subscriptionPlan: null,
  }),

  getters: {
    isStartupPlan(state): boolean {
      return state.subscriptionPlan === "plugin_startup";
    },

    isExpansionOrHigher(state): boolean {
      return (
        state.subscriptionPlan === "plugin_expansion" ||
        state.subscriptionPlan === "plugin_all_features"
      );
    },

    isBusinessOrHiger(state): boolean {
      return (
        state.subscriptionPlan === "plugin_expansion" ||
        state.subscriptionPlan === "plugin_all_features"
      );
    },
  },

  actions: {
    setSubscriptionPlan(plan: SubscriptionPlanResponse) {
      this.subscriptionPlan = "plugin_all_features";

      if (plan === "plugin_50") {
        this.subscriptionPlan = "plugin_startup";
        return;
      }

      if (plan === "plugin_expansion") {
        this.subscriptionPlan = "plugin_expansion";
        return;
      }

      if (
        plan === "plugin_unlimited_yearly" ||
        plan === "plugin_unlimited_monthly" ||
        plan === "plugin_1000" ||
        plan === "admin"
      ) {
        this.subscriptionPlan = "plugin_all_features";
        return;
      }
    },
  },
});
